import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EndpointService} from './endpoint.service';
import {map, Observable, of, shareReplay} from 'rxjs';
import {MobileAppVersion} from '../models/mobile-app-version';

@Injectable({
  providedIn: 'root'
})
export class MobileappversionService {
  private _version: MobileAppVersion;
  private _lastUpdateDate: number;
  private _cacheTime: number = 6 * 3600;
  constructor(private _http: HttpClient) { }

  getRequiredVersion(): Observable<MobileAppVersion> {
    if (this._version && !this.cacheExpired()) {
      return of(this._version);
    }

    return this._http.get<MobileAppVersion>(EndpointService.mobileAppEndpoint)
      .pipe(shareReplay())
      .pipe(map(value => {
        this.updateCache(value);
        return value;
      }));
  }

  updateCache(version: MobileAppVersion) {
    this._lastUpdateDate = Date.now();
    this._version = version;
  }

  private cacheExpired() {
    const now = Date.now();
    return (now - this._lastUpdateDate) / 1000 > this._cacheTime;
  }
}
